<template>
  <div style="width: 400px;height: 400px;" :id="piePicId" />
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "PieCard",
  data(){
    return {
      piePicId: '',
      info: {
        types: [],
        spotSize: 1,
        tip: [],
        source: []
      },
      COLOR_ALL: [
        '#37A2DA', '#e06343', '#37a354', '#b55dba',
        '#b5bd48', '#8378EA', '#96BFFF', '#E72178',
        '#354E6C', '#EAAC31', '#EAD2AE', '#127678',
        '#30B5A4', '#B4D9D2', '#354581','#FFE074',
        '#E03C79', '#88C1B8', '#FC6746','#F5B307',
        '#008186'
      ],
    }
  },
  props:{
    cardID: String,
  },
  mounted() {
    this.piePicId = 'pie_pic' + this.cardID
    this.info = this.$attrs.data.info
    // console.log(this.$attrs)
    // console.log(this.$attrs.data.info_type)
    this.$nextTick(function () {
      this.initPieEcharts(this.$attrs.data.info_type)
    })
  },
  methods: {
    initPieEcharts(dataName){
      let _this = this
      let types = _this.info.types
      let count = []
      for (let i = 0; i < types.length; i++){
        count.push(0)
      }
      for (let i = 1; i < _this.info.source.length; i++){
        let temp_index = types.indexOf(_this.info.source[i][0])
        count[temp_index] = count[temp_index]+1
      }
      let data = []
      for (let i = 0; i < types.length; i++){
        data.push({value: count[i], name: types[i] })
      }
      let _div = document.getElementById(_this.piePicId);
      const chart = echarts.init(_div);
      let mytitle = dataName.substr(0, dataName.length-5)
      if (mytitle === "classification"){
        mytitle = "domain"
      }
      let option;
      option = {
        title: {
          text: mytitle,
          left: 'center'
        },
        toolbox: {
          show : true,
          feature : {
            dataView : {
              title: "dataView",
              show: true
            },
            restore : {
              title: "restore",
              show: true
            },
            saveAsImage : {
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}({d}%)'
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          type: 'scroll',
          // orient: 'vertical',
          // left: 'left'
          orient: 'horizontal',
          bottom: 0
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      option && chart.setOption(option);
    },
  }
}
</script>

<style scoped>

</style>
